<template>
  <div>
    <slot></slot>

    <slot v-if="!loading && list.length === 0" name="empty-view">
      <div
        v-animate-css="'fadeIn'"
        class="d-flex flex-column align-items-center justify-content-center py-5 px-2"
      >
        <b-img
          v-if="emptyImage"
          :src="emptyImage"
          :alt="$config.altImage"
          width="200"
          height="200"
          class="mb-4"
        />

        <h4 v-if="emptyTitle" class="text-muted text-center font-weight-bold">
          {{ emptyTitle }}
        </h4>

        <span v-if="emptyDescription" class="text-muted text-center">
          {{ emptyDescription }}
        </span>

        <brb-btn
          v-if="emptyActionText"
          v-bind="emptyActionBind"
          class="mt-4"
          @click="$emit('empty-action-clicked')"
        >
          {{ emptyActionText }}
        </brb-btn>
      </div>
    </slot>

    <div class="d-flex align-items-center justify-content-center">
      <b-spinner v-if="loading && list.length === 0" class="m-5" />

      <brb-btn
        v-if="list.length < total"
        variant="brb-primary"
        :loading="loading"
        @click="loadMore"
      >
        {{ $t('forms.more') }}
      </brb-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrbListWrapper',
  props: {
    list: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    emptyImage: {
      type: String,
      default: () => require('@/assets/img/open-box.svg')
    },
    emptyTitle: {
      type: String,
      default: function () {
        return this.$t('shared.nothingFound')
      }
    },
    emptyDescription: {
      type: String
    },
    emptyActionText: {
      type: String
    },
    emptyActionBind: {
      type: Object
    },
    loading: Boolean
  },
  methods: {
    loadMore() {
      this.$emit('update:currentPage', this.currentPage + 1)
      this.$nextTick(() => {
        this.$emit('load-more')
      })
    }
  }
}
</script>
